export default __webpack_public_path__ + "Published.9b373328.svg";